import React from 'react';

import { StandardCardSmall } from '@components/pageModules/cards/standardCardSmall';
import { FilterHits } from '../../components/search/filterHits';
import { useSiteContext } from '@lib/context';
import { useFilters } from '@lib/context';

export const PortalGrid = ({ nodes, className, dontNuke }) => {
  const { state } = useSiteContext();
  const { nukeFilters } = useFilters();

  React.useEffect(() => {
    !dontNuke && nukeFilters();
  }, []);

  return (
    <>
      {state?.filters?.searchQuery.length > 0 ? (
        <FilterHits />
      ) : (
        <div
          className={`${className} px-gutter grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 pt-10 gap-x-4 gap-y-6 md:gap-y-4 relative z-10`}>
          {nodes?.length > 0 ? (
            nodes?.map((node, i) => (
              <StandardCardSmall key={i} {...node} className='w-full' />
            ))
          ) : (
            <h2 className='text-center text-teal blockH2 py-24 w-full col-start-1 col-end-4'>
              No results found
            </h2>
          )}
        </div>
      )}
    </>
  );
};
